import { __assign } from './__helpers/tslib/tslib.es6.js';
import { Obj } from '@mongez/reinforcements';
import { serialize } from './utils.js';

var defaultConfigurations = {
    baseUrl: "",
    putToPost: false,
    putMethodKey: "_method",
    formDataToJSON: false,
    formDataToJSONSerializer: serialize,
};
var currentConfigurations = __assign({}, defaultConfigurations);
/**
 * Set http configurations, this will override any previous configurations or merge with new onces
 * @param configurations
 */
function setHttpConfigurations(configurations) {
    currentConfigurations = Obj.merge(currentConfigurations, configurations);
}
function getHttpConfigurations() {
    return currentConfigurations;
}
function getHttpConfig(key, defaultValue) {
    return Obj.get(currentConfigurations, key, defaultValue);
}

export { getHttpConfig, getHttpConfigurations, setHttpConfigurations };
